import { render, staticRenderFns } from "./form2Offers.vue?vue&type=template&id=0589c4a3&scoped=true"
import script from "./form2Offers.vue?vue&type=script&lang=js"
export * from "./form2Offers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0589c4a3",
  null
  
)

export default component.exports